import { i18n } from '../../i18n'
import DateConverter from '../../utils/date-convert'
import { makeCancellable, takeLatest } from 'vuex-cancellable-actions'
import moment from 'moment'
import { getEquipmentData, toggleEquipmentFavorite, getWorkRequestsTable, getEquipmentInfo } from '../../api/equipment-data/api.js'
import { getAllAttachments } from '../../api/attachments/api.js'
import settings from '../../../public/settings.json'

const state = {
  equipmentData: {},
  allEquipment: [],
  attachments: [],
  passportWorkRequests: []
  // onlyMyEquipmentFlag: false
}

const getters = {
  equipmentData: state => state.equipmentData,
  passportWorkRequests: state => state.passportWorkRequests,
  allEquipment: state => state.allEquipment,
  // onlyMyEquipmentFlag: state => state.onlyMyEquipmentFlag,
  equipmentMainInfoListData: (state) => {
    const items = []
    if (state.equipmentData) {
      items.push({
        header: true,
        title: i18n.t('equipment.mainInfo.equipmentData')
      })
      if (state.equipmentData.ObjectName && state.equipmentData.ObjectName.length) {
        items.push({
          icon: 'home',
          title: i18n.t('equipment.mainInfo.objectName'),
          subtitle: state.equipmentData.ObjectName
        })
      }
      if (state.equipmentData.DepartmentName && state.equipmentData.DepartmentName.length) {
        items.push({
          icon: 'domain',
          title: i18n.t('equipment.mainInfo.departmentName'),
          subtitle: state.equipmentData.DepartmentName
        })
      }
      if (state.equipmentData.TypeName && state.equipmentData.TypeName.length) {
        items.push({
          icon: 'title',
          title: i18n.t('equipment.mainInfo.typeName'),
          subtitle: state.equipmentData.TypeName
        })
      }
      if (state.equipmentData.ModelName && state.equipmentData.ModelName.length) {
        items.push({
          icon: 'settings',
          title: i18n.t('equipment.mainInfo.modelName'),
          subtitle: state.equipmentData.ModelName
        })
      }
      if (state.equipmentData.InstallDateString && state.equipmentData.InstallDateString.length) {
        items.push({
          icon: 'query_builder',
          title: i18n.t('equipment.mainInfo.installDateString'),
          subtitle: state.equipmentData.InstallDateString
        })
      }
      if (state.equipmentData.FactoryNumber && state.equipmentData.FactoryNumber.length) {
        items.push({
          icon: 'notes',
          title: i18n.t('equipment.mainInfo.factoryNumber'),
          subtitle: state.equipmentData.FactoryNumber
        })
      }
      if (state.equipmentData.Category && state.equipmentData.Category.length) {
        items.push({
          icon: 'view_carousel',
          title: i18n.t('equipment.mainInfo.category'),
          subtitle: state.equipmentData.Category
        })
      }
      if (state.equipmentData.AdditionalData) {

        let headerAdded = false

        let i = 1
        let iconName = ''

        for (let caption in state.equipmentData.AdditionalData) {

          if (state.equipmentData.AdditionalData[caption]) {
            if (!headerAdded) {
              headerAdded = true
              items.push({
                header: true,
                title: i18n.t('equipment.mainInfo.additionalName')
              })
            }
            (i <= 9) ? (iconName = 'filter_' + i++) : (iconName = 'filter_9_plus')

            items.push({
              icon: iconName,
              title: caption,
              subtitle: state.equipmentData.AdditionalData[caption]
            })
          }

        }
      }

      //////////////////////////////////////
      if (state.equipmentData.LastRepairDateString
        || state.equipmentData.LastWorkRequestDate
        || state.equipmentData.NextRepairDateString
        || state.equipmentData.WarrantyDate) {
        items.push({
          header: true,
          title: i18n.t('equipment.mainInfo.state')
        })
        // if (state.equipmentData.HeatNumber) {
        //     items.push({
        //         icon: "assignment_turned_in",
        //         title: "Номер плавки",
        //         subtitle: state.equipmentData.HeatNumber
        //     });
        // }
        if (state.equipmentData.LastRepairDateString && state.equipmentData.LastRepairDateString.length) {
          items.push({
            icon: 'alarm_on',
            title: i18n.t('equipment.mainInfo.lastRepairDateString'),
            subtitle: state.equipmentData.LastRepairDateString
          })
        }

        if (state.equipmentData.LastWorkRequestDate && state.equipmentData.LastWorkRequestDate.length) {
          items.push({
            icon: 'query_builder',
            title: i18n.t('equipment.mainInfo.lastWorkRequestDate'),
            subtitle: state.equipmentData.LastWorkRequestDate
          })
        }
        if (state.equipmentData.NextRepairDateString && state.equipmentData.NextRepairDateString.length) {
          items.push({
            icon: 'query_builder',
            title: i18n.t('equipment.mainInfo.nextRepairDateString'),
            subtitle: state.equipmentData.NextRepairDateString
          })
        }
        // if (state.equipmentData.SensorsCount) {
        //     state.push({
        //         icon: "line_style",
        //         title: "Привязано датчиков",
        //         subtitle: state.equipmentData.SensorsCount
        //     });
        // } 
        if (state.equipmentData.WarrantyDate && state.equipmentData.WarrantyDate.length) {
          const iconColor =
            new Date(DateConverter.parseDate(state.equipmentData.WarrantyDate)) > new Date() ?
              'green' :
              'orange'
          items.push({
            icon: 'verified_user',
            color: iconColor,
            title: i18n.t('equipment.mainInfo.warrantyDate'),
            subtitle: state.equipmentData.WarrantyDate
          })
        }
      }
      //////////////////////////////////////
      if ((state.equipmentData.ResponsibleSpecialists
        && state.equipmentData.ResponsibleSpecialists.length
        && state.equipmentData.ResponsibleName.length)
        || state.equipmentData.ResponsibleName) {

        items.push({
          header: true,
          title: i18n.t('equipment.mainInfo.responsibleName')
        })

        if (state.equipmentData.ResponsibleName) {
          items.push({
            icon: 'person',
            color: 'blue',
            title: state.equipmentData.ResponsibleName
          })
        }

        for (var spec in state.equipmentData.ResponsibleSpecialists) {
          items.push({
            icon: 'person',
            title: state.equipmentData.ResponsibleSpecialists[spec]
              .ResponsibleName,
            subtitle: state.equipmentData.ResponsibleSpecialists[spec]
              .DirectionName,
            info: state.equipmentData.ResponsibleSpecialists[spec].PhoneNumber
          })
        }
      }
    }
    return items
  }
}

const actions = makeCancellable({
  updateAllEquipment: takeLatest(async function ({ dispatch }, payload) {
    await dispatch('updateEquipmentData', payload)
  }),
  updateEquipmentData: takeLatest(async function ({ getters, commit }, payload) {
    payload.isAuth = getters.isAuthenticated
    if (payload.equipmentCode) {
      commit('setEquipmentData', {})
      commit('setPassportWorkRequests', [])
      // const getParams = {
      //   objName,
      //   commitName: '',
      //   parameters: payload,
      //   cacheKey: payload.equipmentCode,
      //   skipCache: !!payload.skipCache,
      // }
      // let data = await dispatch('getItemsFromCache', getParams)
      // if ((data || {}).EquipmentId) {
      //   data.Cache = true
      //   commit('setEquipmentData', data)
      // }
      const data = await getEquipmentInfo(payload)
      if (data) {
        data.Cache = false
        commit('setEquipmentData', data)
      }
    } else {
      // const obj = payload.onlyMy
      //   ? 'MyEquipmentInfo'
      //   : payload.onlyFav
      //     ? 'FavEquipmentInfo'
      //     : 'AllEquipmentInfo'
      // const getParams = {
      //   objName: obj,
      //   commitName: '',
      //   parameters: payload,
      //   cacheKey: obj,
      //   skipCache: payload
      //     ? payload.skipCache || !!payload.search || payload.search == null
      //     : false,
      // }
      // let data = await dispatch('getItemsFromCache', getParams)
      // if (data) {
      //   commit('setAllEquipment', data)
      // }
      const data = await getEquipmentData(payload)
      //data = await dispatch('
      // ', getParams)
      if (data) {
        commit('setAllEquipment', data)
      }
    }
  }),
  async toggleEquipmentFav( payload) {
    payload.IsFavorite = !payload.IsFavorite
    await toggleEquipmentFavorite({
      equipmentCode: payload.EquipmentId,
      addToFav: payload.IsFavorite
    })
  },
  async updatePassportWorkRequests({ commit, getters }, payload) {
    if (getters.isAuthenticated && getters.isOnline) {
      commit('setLoading', true)
      try {
        const data = await getWorkRequestsTable(payload)
        if (data) {
          commit('setPassportWorkRequests', data)
          commit('setLoading', false)
        } else {
          commit('setLoading', false)
        }
      }
      catch (error) {
        commit('setError', error.message)
        commit('setLoading', false)
      }
    }
  },
  updateEquipmentAttachments: takeLatest(async function ({ commit, getters }, payload) {
    if (getters.isAuthenticated && getters.isOnline && payload) {
      commit('setLoading', true)
      try {
        commit('setEquipmentAttachments', [])
        const equipmentFiles = payload.equipmentCode ? await getAllAttachments({ table: 'ROK', keyValue: payload.equipmentCode }) : []
        const modelFiles = payload.modelCode ? await getAllAttachments({ table: 'KSM', keyValue: payload.modelCode.padStart(15, ' ') }) : []
        let files = []
        if (equipmentFiles && equipmentFiles.length) {
          files = equipmentFiles
        }
        if (modelFiles && modelFiles.length) {
          files = [...files, ...modelFiles]
        }
        commit('setEquipmentAttachments', files)
        commit('setLoading', false)
      }
      catch (error) {
        commit('setError', error.message)
        commit('setLoading', false)
      }
    }
  }),
})

const mutations = {
  setAllEquipment(state, payload) {
    state.allEquipment = payload
  },
  setEquipmentData(state, payload) {
    if (payload.Images && Array.isArray(payload.Images)) {
      payload.PassportImages = payload.Images.map(hash => settings.wsPath + 'GetFile.ashx?file=' + hash)
    } else {
      payload.PassportImages = []
    }
    state.equipmentData = payload
  },
  // setMyEquipmentFlag(state, payload) {
  //     state.onlyMyEquipmentFlag = payload;
  // },
  setEquipmentAttachments(state, payload) {
    state.attachments = payload
  },
  setPassportWorkRequests(state, payload) {
    payload.forEach(item => {
      item.sortablePlanStart = moment(item.DatePlanString, 'DD.MM.YYYY').toDate().valueOf()
      item.sortablePlanEnd = moment(item.DatePlanEndString, 'DD.MM.YYYY').toDate().valueOf()
    })
    state.passportWorkRequests = payload

  }
}

export default {
  state,
  getters,
  actions,
  mutations
}